import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useSettings } from "@/lib/settings";
import { API, errMsg, priceFor } from "@/lib/api";
import GalleryLinks from "@/components/GalleryLinks";
import AthleteFields from "@/components/order/AthleteFields";
import EventsFields from "@/components/order/EventsFields";
import PaymentBox from "@/components/order/PaymentBox";
import OrderSuccess from "@/components/order/OrderSuccess";

const emptyForm = { parent_name: "", whatsapp: "", athlete_name: "", bib_number: "", club: "", category: "", notes: "" };
const emptyEvent = { name: "", day: "", photos: "" };

export default function OrderPage() {
  const { settings } = useSettings();
  const [form, setForm] = useState(emptyForm);
  const [events, setEvents] = useState([{ ...emptyEvent }]);
  const [proof, setProof] = useState(null);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);
  const total = priceFor(events.length, settings?.prices);

  const submit = async (e) => {
    e.preventDefault();
    if (events.some((ev) => !ev.name || !ev.day || !ev.photos)) return toast.error("Lengkapi semua data mata lomba & nama file foto");
    if (!proof) return toast.error("Unggah bukti transfer terlebih dahulu");
    const fd = new FormData();
    fd.append("data", JSON.stringify({ ...form, events }));
    fd.append("proof", proof);
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/orders`, fd);
      setDone(data);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      toast.error(errMsg(err, "Gagal mengirim pesanan"));
    } finally {
      setLoading(false);
    }
  };

  if (done) return <OrderSuccess order={done} settings={settings} />;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 md:py-16" data-testid="order-page">
      <h1 className="font-display font-black uppercase italic text-4xl sm:text-5xl lg:text-6xl">Form <span className="text-[#FF5A00]">Pesan Foto</span></h1>
      <p className="text-neutral-400 mt-2">1) Pilih foto di galeri · 2) Isi form · 3) Upload bukti transfer</p>
      <section className="mt-8">
        <p className="font-display uppercase font-bold text-lg text-neutral-300">Galeri Google Drive</p>
        <GalleryLinks links={settings?.drive_links} compact />
      </section>
      <form onSubmit={submit} className="mt-10 space-y-10">
        <AthleteFields form={form} setForm={setForm} />
        <EventsFields events={events} setEvents={setEvents} days={settings?.drive_links || []} eventOptions={settings?.event_options || []} emptyEvent={emptyEvent} />
        <PaymentBox settings={settings} total={total} count={events.length} proof={proof} setProof={setProof} />
        <button type="submit" disabled={loading} data-testid="submit-order-btn"
          className="w-full bg-[#FF5A00] hover:bg-[#E04F00] disabled:opacity-60 active:scale-[0.98] transition-[background-color,transform] duration-150 py-5 font-display font-black uppercase text-2xl flex items-center justify-center gap-2">
          {loading && <Loader2 className="w-6 h-6 animate-spin" />} Kirim Pesanan
        </button>
      </form>
    </div>
  );
}
